import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wordpress': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M61.7 169.4L163.2 447.4C92.2 413 43.3 340.2 43.3 256 43.3 225.1 49.9 195.9 61.7 169.4zM399.6 245.3C399.6 219 390.2 200.8 382.1 186.6 371.3 169.1 361.2 154.2 361.2 136.7 361.2 117.1 376 98.9 396.9 98.9 397.8 98.9 398.7 99 399.7 99.1 361.8 64.4 311.4 43.2 256 43.2 181.7 43.2 116.3 81.3 78.2 139.1 83.2 139.3 87.9 139.4 91.9 139.4 114.1 139.4 148.6 136.7 148.6 136.7 160.1 136 161.4 152.9 150 154.2 150 154.2 138.5 155.5 125.7 156.2L203.2 386.6 249.8 247 216.7 156.2C205.2 155.5 194.4 154.2 194.4 154.2 182.9 153.5 184.3 136 195.7 136.7 195.7 136.7 230.8 139.4 251.7 139.4 273.9 139.4 308.4 136.7 308.4 136.7 319.9 136 321.2 152.9 309.8 154.2 309.8 154.2 298.3 155.5 285.5 156.2L362.4 384.9 383.6 314C392.6 284.6 399.6 263.5 399.6 245.3zM259.7 274.6L195.9 460.1C215 465.7 235.1 468.8 256 468.8 280.8 468.8 304.5 464.5 326.6 456.7 326 455.8 325.5 454.8 325.1 453.8L259.7 274.6zM442.7 153.9C443.6 160.7 444.1 167.9 444.1 175.8 444.1 197.4 440.1 221.6 427.9 252L362.9 439.9C426.2 403 468.7 334.5 468.7 256 468.7 219 459.3 184.2 442.7 153.9zM504 256C504 392.8 392.7 504 256 504 119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8 392.7 8 504 119.2 504 256zM492.6 256C492.6 125.5 386.4 19.4 256 19.4 125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6C386.5 492.6 492.6 386.5 492.6 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wordpress.js
// module id = Qm2Y
// module chunks = 144